import EntityTypeEnum from 'common/enums/entityTypeEnum'
import { BorderStyleEnum, BorderTypeEnum } from 'common/types/styleTypes'
import { generateBaseEntity } from 'src/shared/entities/utils/generate-base-entity'
import { MasterBlockIdType } from 'src/shared/schemas/master-block-id.schema'
import { SearchInterface } from 'src/shared/types/entities/search-interface'

export const createSearch = (
  parentId: string,
  masterBlockId?: MasterBlockIdType,
): SearchInterface => {
  return {
    ...generateBaseEntity(EntityTypeEnum.Search, parentId, masterBlockId),
    dropdown: {
      backgroundColor: '#FFFFFF',
      boxShadow: '0px 10px 8px 0px #0000000A',
      margin: {
        marginTop: 20,
        marginBottom: 20,
        marginLeft: 0,
        marginRight: 0,
      },
      border: {
        width: 1,
        style: BorderStyleEnum.solid,
        color: '#E5E7EB',
        radius: 10,
        type: BorderTypeEnum.fullBorder,
      },
    },
    item: {
      padding: {
        paddingBottom: 12,
        paddingLeft: 12,
        paddingRight: 12,
        paddingTop: 12,
      },
    },
    seeMore: {
      fontSize: 12,
      alignSelf: 'flex-start',
      color: '#00A0FF',
      fontWeight: '700',
      padding: {
        paddingTop: 8,
        paddingBottom: 8,
        paddingLeft: 24,
        paddingRight: 24,
      },
    },
    itemTitle: {
      fontSize: 14,
      textAlign: 'left',
      color: '#1F2937',
    },
    itemText: {
      fontSize: 12,
      textAlign: 'left',
      color: '#6B7280',
    },
    input: {
      fontSize: 15,
      textAlign: 'left',
      color: '#6B7280',
      padding: {
        paddingBottom: 10,
        paddingLeft: 12,
        paddingRight: 50,
        paddingTop: 10,
      },
      backgroundColor: '#FFFFFF',
      border: {
        width: 1,
        style: BorderStyleEnum.solid,
        color: '#E5E7EB',
        radius: 10,
        type: BorderTypeEnum.fullBorder,
      },
    },
  } as SearchInterface
}

export {
  getSearchCustomFontProperties,
  getSearchFontProperties,
} from 'src/shared/entities/search/utils/get-search-font-properties'
